module.exports = __webpack_public_path__ + "img/graphic.3002d8ae.svg";